const state = {
}

export default state



// WEBPACK FOOTER //
// ./module/passport/src/store/state.js